// ============================================================
// 슬라이더 "정류장" 계산 유틸
//
// 왜 필요한가:
//   구간마다 단위가 다른 슬라이더(예: 5억까지 5천만씩, 그 위는 1억씩)를
//   수식으로 계산하려면 코드가 복잡해진다.
//   대신 가능한 값들을 미리 배열로 만들어두고,
//   슬라이더는 "몇 번째 정류장인가"만 다루게 하면 아주 단순해진다.
//   (버스가 3.7km 지점이 아니라 '3번 정류장'에 서는 것과 같은 원리)
//
// 사용처: SliderConfigManager(관리화면), RangeSlider(필터 UI) 양쪽
// ============================================================

// 소수점 오차 정리용 (0.1+0.2=0.30000000000000004 같은 문제 방지)
const round = (n) => Math.round(n * 1000) / 1000;

/**
 * 설정 → 정류장 값 배열
 * 예: {min:0, segments:[{to:5000,step:500},{to:50000,step:5000}]}
 *  →  [0,500,1000,...,5000,10000,...,50000]
 */
export function buildStops(cfg, skipZero = false) {
  const min = Number(cfg?.min ?? 0);
  const segs = Array.isArray(cfg?.segments) ? cfg.segments : [];

  const stops = [min];
  let cur = min;

  for (const s of segs) {
    const to = Number(s?.to);
    const step = Number(s?.step);
    // 잘못된 설정은 건너뛴다. step<=0 이면 무한루프가 되므로 특히 중요.
    if (!Number.isFinite(to) || !Number.isFinite(step)) continue;
    if (step <= 0 || to <= cur) continue;

    // 정류장이 너무 많아지면 브라우저가 느려지므로 안전장치를 둔다
    let guard = 0;
    while (round(cur + step) <= to && guard < 3000) {
      cur = round(cur + step);
      stops.push(cur);
      guard++;
    }
    // 마지막 자투리(예: step 3 으로 10까지면 9 다음 10)를 채운다
    if (cur < to) { cur = to; stops.push(cur); }
  }
  // [SKIP_ZERO_V1] 층수처럼 0 이 없는 항목은 여기서 0 을 제거한다
  if (skipZero) {
    const filtered = stops.filter((v) => v !== 0);
    if (filtered.length > 1) return filtered;
  }
  return stops;
}

/**
 * 임의의 값 → 가장 가까운 정류장의 번호(index)
 * 숫자 입력칸에 직접 타이핑했을 때 슬라이더 손잡이를 어디에 세울지 정한다.
 */
export function nearestIndex(stops, value) {
  const v = Number(value);
  if (!Number.isFinite(v) || stops.length === 0) return 0;
  let best = 0, bestGap = Infinity;
  for (let i = 0; i < stops.length; i++) {
    const gap = Math.abs(stops[i] - v);
    if (gap < bestGap) { bestGap = gap; best = i; }
  }
  return best;
}

/** 화면 표시용 천단위 콤마 */
export function fmt(n) {
  const v = Number(n);
  return Number.isFinite(v) ? v.toLocaleString("ko-KR") : "";
}
